import { getOwner } from "@ember/owner";
import Service, { service } from "@ember/service";

export default class Circle extends Service {
  @service circles;
  @service router;

  get viewingCircle() {
    return this.#isCircleRoute(this.router.currentRoute);
  }

  get slugPathWithId() {
    if (!this.viewingCircle) {
      return;
    }

    return this.#extractSlugPathWithidFromRoute(this.router.currentRoute);
  }

  get model() {
    if (!this.viewingCircle) {
      return;
    }

    return getOwner(this).lookup("route:circle").modelFor("circle");
  }

  get userCanCreateTopic() {
    return this.circles.userCanCreateTopic(this.model);
  }

  get userIsMember() {
    return this.circles.userIsMember(this.model);
  }

  #isCircleRoute(currentRoute) {
    return !!(
      currentRoute?.name?.startsWith("circle.") ||
      currentRoute.localName === "circle"
    );
  }

  #extractSlugPathWithidFromRoute(routeInfo) {
    if (!this.#isCircleRoute(routeInfo)) {
      return;
    }
    if (routeInfo.localName === "circle") {
      return routeInfo?.params?.slug_path_with_id;
    }

    return this.#extractSlugPathWithidFromRoute(routeInfo.parent);
  }
}
